import McLabel from './McLabel.vue'

McLabel.install = function(Vue){
    Vue.component(McLabel.name, McLabel);
}

export default McLabel;